import PropTypes from 'prop-types'

export function Properties({ children, className }) {
  return (
    <div
      className={
        className
          ? `${className} tw-text-sm tw-leading-relaxed`
          : `tw-text-sm tw-leading-relaxed`
      }>
      {children}
    </div>
  )
}

Properties.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export function Property({ title, value, unit }) {
  return (
    <p
      className={`tw-m-0 ${
        title === 'Platform' ? 'tw-hidden show-for-ph' : ''
      }`}>
      <span className="tw-text-system-grey-400 tw-normal-case">{title}</span>:{' '}
      {value}
      {unit && <span>&nbsp;{unit}</span>}
    </p>
  )
}

Property.propTypes = {
  title: PropTypes.node,
  value: PropTypes.node,
  unit: PropTypes.string,
}
